import { Input } from '../components/Input';
import { useTranslation } from 'react-i18next';

interface UserProfileProps {
    username: string;
    email: string;
}

/**
 * ユーザープロファイル表示コンポーネント
 * @param username ユーザー名
 * @param email ユーザーのメールアドレス
 * @returns ユーザープロファイル表示
 */
export const UserProfile = ({ username, email }: UserProfileProps) => {
    const { t } = useTranslation('settings');
    const usernameValue = username || t('user.fields.usernamePlaceholder');

    return (
        <div className="flex flex-col gap-6">
            <h2 className="text-lg font-medium">{t('user.heading')}</h2>
            {/* ユーザー名 */}
            <div className="flex">
                <span className="inline-flex items-center h-10 px-3 text-sm bg-gray-100 border border-r-0 border-gray-200 rounded-l-md">
                    {t('user.fields.username')}
                </span>
                <Input
                    type="text"
                    value={usernameValue}
                    className="flex-1 h-10 rounded-l-none cursor-not-allowed"
                    placeholder=""
                    aria-label="Username"
                    onFocus={(e) => e.target.blur()}
                    readOnly
                />
            </div>
            {/* メールアドレス */}
            <div className="flex">
                <span className="inline-flex items-center h-10 px-3 text-sm bg-gray-100 border border-r-0 border-gray-200 rounded-l-md">
                    {t('user.fields.email')}
                </span>
                <Input
                    type="text"
                    value={email}
                    className="flex-1 h-10 rounded-l-none cursor-not-allowed"
                    placeholder={t('user.fields.emailPlaceholder')}
                    aria-label="Username"
                    onFocus={(e) => e.target.blur()}
                    readOnly
                />
            </div>
        </div>
    );
};

export default UserProfile;
